<template>
    <span class="show-type" :class="showTypeCssClass" :title="type">{{ type }}</span>
</template>

<script>
export default {
    props: ['type'],
    computed: {
        showTypeCssClass() {
            return 'show-type-' + this.type.toLowerCase().replace(/ /g, '-');
        },
    },
};
</script>
